const B_1 = [
    {
        title: '评标报告列表',
        path: '/bidding/projectflow/ping/pbbg/list'
    }
]
export default {
    path: 'pbbg',
    component: () => import(/*webpackChunkName: 'bidding-ping-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-bao-gao/list'),
            meta: {
                title: '评标报告列表',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-bao-gao/detail'),
            meta: {
                title: '评标报告详情',
                bread: B_1
            },
        },
        {
            path:"onlineEdit",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-bao-gao/onlineEditTemplate'),
            meta: {
                title: '在线编辑',
                bread: B_1
            },
        },
        {
            path:"pbbg",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-bao-gao/pbbg'),
            meta: {
                title: '评标报告',
                bread: B_1
            },
        },
    ]
}